<template>
	<div class="list">
		<!-- 新增批量删除按钮 -->
		<slot name="add-but">
			<div style="margin-top: 20px">
				<a-button type="primary" icon="plus" @click="() => $emit('addRow')" :disabled="justLook" v-if="addTitle">
					{{ addTitle }}
				</a-button>
				<a-dropdown v-if="isChecked && selectedRowKeys.length > 0">
					<a-menu slot="overlay">
						<slot name="batch-action">
							<a-menu-item key="1" @click="() => $emit('delBath')"> <a-icon type="delete" />删除 </a-menu-item>
						</slot>
					</a-menu>
					<a-button style="margin-left: 8px"> 批量操作<a-icon type="down" /> </a-button>
				</a-dropdown>
			</div>
		</slot>
		<!-- 列表区域 -->
		<div>
			<div v-if="isChecked" class="ant-alert ant-alert-info" style="margin-top: 20px">
				<i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a> 项
				<a style="margin-left: 24px" @click="onClearSelected">清空</a>
			</div>
			<!-- 表格区域 -->
			<a-table
				style="margin-top: 20px"
				ref="table"
				size="middle"
				bordered
				:rowKey="rowKey"
				:columns="columns"
				:dataSource="dataSource"
				:pagination="pagination"
				:loading="loading"
				:rowClassName="setRowClassName"
				:rowSelection="isChecked ? { selectedRowKeys: selectedRowKeys, onChange: onSelectChange } : null"
				@change="(ipagination) => $emit('handleTableChange', ipagination)"
			>
				<!-- 模板内容 -->
				<span
					v-for="(item, ind) in columns.filter((one) => one.scopedSlots && one.scopedSlots.customRender)"
					:slot="item.scopedSlots.customRender"
					slot-scope="text, record, index"
					:key="ind"
				>
					<slot :name="item.scopedSlots.customRender" :text="text" :record="record" :index="index" />
				</span>
			</a-table>
		</div>
	</div>
</template>

<script>
import { deepClone } from "@/utils/deepclone";
import pagination from "@/utils/pagination";
export default {
	props: {
		addTitle: {
			type: String,
			default: () => "新增",
		},
		// 列键
		columns: {
			type: Array,
			default: () => [],
		},
		// 数据
		dataSource: {
			type: Array,
			default: () => [],
		},
		// 分页
		pagination: {
			type: [Object, Boolean],
			default: () => {
				return deepClone(pagination);
			},
		},
		// 加载中
		loading: {
			type: Boolean,
			default: () => false,
		},
		// 列表选中的唯一标识
		rowKey: {
			type: String,
			default: () => "id",
		},
		// 是否有多选
		isChecked: {
			type: Boolean,
			default: () => true,
		},
		// 是否只查看
		justLook: { type: Boolean, default: false },
	},
	data() {
		return {
			selectedRowKeys: [],
			selectionRows: [],
		};
	},

	methods: {
		// table选择框
		onSelectChange(selectedRowKeys, selectionRows) {
			this.selectedRowKeys = selectedRowKeys;
			this.selectionRows = selectionRows;
		},
		// 清空
		onClearSelected() {
			this.selectedRowKeys = [];
			this.selectionRows = [];
		},
		// setRowClassName
		setRowClassName(record, index) {
			//   console.log("设置类名", record, index);
			//   if (record.need == "delete") {
			//     return "none-row";
			//   }
		},
	},
};
</script>

<style lang="less" scoped>
.list {
	::v-deep .ant-table-pagination.ant-pagination {
		float: none;
		text-align: center;
	}
}
::v-deep .none-row {
	display: none;
}
// 去除列表的margin-top
.wz-none-table-top {
	::v-deep .ant-table-wrapper {
		margin-top: 0 !important;
	}
}
.wz-none-checkeds-top {
	.ant-alert {
		margin-top: 0 !important;
	}
}
</style>
